import { render } from "./SpendingPotButton.vue?vue&type=template&id=bb9107d4&scoped=true"
import script from "./SpendingPotButton.vue?vue&type=script&lang=js"
export * from "./SpendingPotButton.vue?vue&type=script&lang=js"

import "./SpendingPotButton.vue?vue&type=style&index=0&id=bb9107d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9107d4"]])

export default __exports__